import rolesReducer from './features/roles/reducer';
import toastsReducer from './features/toasts/reducer';
import userReducer from './features/user/reducer';
import subscriptionsReducer from './features/subscriptions/reducer';
import kycUserReducer from './features/kyc/user/reducer';
import kycEntityReducer from './features/kyc/entity/reducer';
import projectReducer from './features/projects/reducer';
var rootReducer = {
    roles: rolesReducer,
    toasts: toastsReducer,
    user: userReducer,
    subscriptions: subscriptionsReducer,
    kycUser: kycUserReducer,
    kycEntity: kycEntityReducer,
    projects: projectReducer,
};
export default rootReducer;
